import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Header from "../inc/Header";
import Footer from "../inc/Footer";
import PostWrapper from "./PostWrapper";
import BottomToTop from "../inc/BottomToTop";
import OrderNow from "../inc/OrderNow";
import SignUpForTrial from "../inc/SignUpForTrial";
class Post extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}
  componentDidUpdate(prevProps, prevState, snapshot) {}

  render() {
    return (
      <>
        <Header />
        <PostWrapper />
        <Footer />
        <BottomToTop />
        <OrderNow />
        <SignUpForTrial />
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Post));
